(function () {
  function initProductCarouselTabs(sectionId) {
    var sectionEl = document.getElementById('section-' + sectionId);
    if (!sectionEl) return;

    var slidesPerView = parseInt(sectionEl.getAttribute('data-slides-per-view'), 10) || 4;

    var tabBtns = Array.from(sectionEl.querySelectorAll('.pct-tab-btn'));
    var panels  = Array.from(sectionEl.querySelectorAll('.pct-panel'));
    var prevBtn = sectionEl.querySelector('.pct-arrow--prev');
    var nextBtn = sectionEl.querySelector('.pct-arrow--next');
    var swipers = {};
    var activeIdx = 0;

    function buildSwiper(idx) {
      if (swipers[idx]) {
        swipers[idx].destroy(true, true);
        delete swipers[idx];
      }
      var el = document.getElementById('pct-swiper-' + sectionId + '-' + idx);
      if (!el) return;
      swipers[idx] = new Swiper(el, {
        slidesPerView: 1.5,
        spaceBetween: 30,
        grabCursor: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
        },
        breakpoints: {
          480:  { slidesPerView: 2 },
          750:  { slidesPerView: 3 },
          990: { slidesPerView: slidesPerView },
        },
      });
    }

    function switchTab(idx) {
      if (idx < 0 || idx >= tabBtns.length) return;
      tabBtns.forEach(function (btn) { btn.classList.remove('active'); });
      tabBtns[idx].classList.add('active');
      var prevIdx = activeIdx;
      activeIdx = idx;
      if (prevIdx === idx) {
        buildSwiper(idx);
        return;
      }
      var outgoing = panels[prevIdx];
      var incoming = panels[idx];
      outgoing.style.opacity      = '0';
      outgoing.style.transform    = 'translateY(6px)';
      outgoing.style.pointerEvents = 'none';
      setTimeout(function () {
        outgoing.classList.remove('active');
        outgoing.style.opacity   = '';
        outgoing.style.transform = '';
        incoming.style.opacity   = '0';
        incoming.style.transform = 'translateY(10px)';
        incoming.classList.add('active');
        buildSwiper(idx);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            incoming.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
            incoming.style.opacity    = '1';
            incoming.style.transform  = 'translateY(0)';
            setTimeout(function () {
              incoming.style.opacity    = '';
              incoming.style.transform  = '';
              incoming.style.transition = '';
            }, 360);
          });
        });
      }, 300);
    }

    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(this.getAttribute('data-tab-index'), 10);
        switchTab(idx);
      });
    });

    switchTab(0);
  }

  function getSectionIds() {
    return Array.from(
      document.querySelectorAll('.product-carousel-tabs[data-section-id]')
    ).map(function (el) {
      return el.getAttribute('data-section-id');
    });
  }

  function onLoad() {
    var ids = getSectionIds();
    if (!ids.length) return;
    function run() {
      ids.forEach(function (id) { initProductCarouselTabs(id); });
    }
    if (typeof Swiper !== 'undefined') {
      run();
    } else {
      document.addEventListener('swiper:ready', run);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.product-carousel-tabs[data-section-id]');
    if (!el) return;
    var id = el.getAttribute('data-section-id');
    if (typeof Swiper !== 'undefined') {
      initProductCarouselTabs(id);
    } else {
      document.addEventListener('swiper:ready', function () { initProductCarouselTabs(id); });
    }
  });
})();